import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import ElementUI from 'element-ui';
import '../node_modules/element-ui/lib/theme-chalk/index.css'
import '../src/assets/style/common.less'
Vue.use(ElementUI);
// import style
const vm = new Vue({
  render: (h) => h(App)
})
Vue.prototype.$EventBus = vm
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
